<div class="timepicker">
  <div class="flex flex--align-center">
    <input
      class="timepicker__time-input"
      type="text"
      placeholder="HH"
      [mask]="timeMask"
      [formControl]="hourControl"
      (keypress)="hourKeyPress($event)"
      (blur)="onHourBlur()"
      [attr.disabled]="disabled ? '' : null"
    />
    <div class="m-r-2">:</div>
    <input
      class="timepicker__time-input"
      type="text"
      placeholder="MM"
      [mask]="timeMask"
      [formControl]="minutesControl"
      (keypress)="minutesKeyPress($event)"
      (blur)="onMinutesBlur()"
      [attr.disabled]="disabled ? '' : null"
    />
    <div
      class="timepicker__time-input time-of-day"
      [class.disabled]="disabled"
      (click)="switchTimeOfDay()"
    >
      {{ timeOfDayPlaceholder }}
    </div>
  </div>
</div>
